import * as React from 'react'

function ChevronDownSmallIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.215 7.95a.985.985 0 01.658-.439.917.917 0 01.74.214l7.393 6.298 7.392-6.298a.917.917 0 01.74-.214c.263.042.5.2.658.439.082.119.142.255.176.4a1.263 1.263 0 01-.108.867c-.069.129-.16.241-.267.33l-7.812 6.658a1.198 1.198 0 01-.78.295c-.28 0-.554-.104-.778-.295L3.415 9.547a1.088 1.088 0 01-.267-.33 1.262 1.262 0 01-.108-.867c.034-.145.094-.281.175-.4z'
        fill='currentColor'
      />
    </svg>
  )
}

export default ChevronDownSmallIcon
